import { Bar, BarChart, LabelProps, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { Box, Typography } from '@mui/material';

import { ChartData } from '../../types';
import React from 'react';

// Custom tooltip type
interface CustomTooltipProps {
  active?: boolean;
  payload?: Array<{
    payload: ChartData;
    name: string;
    value: number;
  }>;
}

// Extended label props to include payload
interface ExtendedLabelProps extends LabelProps {
  x?: number;
  y?: number;
  width?: number;
}

export const CustomTooltip: React.FC<CustomTooltipProps> = ({ active, payload }) => {
  if (active && payload?.length) {
    const graphData = payload[0];
    const chartData = graphData.payload;
    
    return (
      <Box 
        sx={{ 
          backgroundColor: 'white', 
          border: '1px solid #ccc', 
          padding: '10px', 
          borderRadius: '5px' 
        }}
      >
        <Typography variant="subtitle2" fontWeight="bold" mb={1}>{chartData.name}</Typography>
        <Typography variant="body2">
          {chartData.count}
        </Typography>
      </Box>
    );
  }
  return null;
};

// Custom label for bar chart
export const BarLabel = (props: ExtendedLabelProps) => {
  // Safely handle undefined or non-numeric values
  const safeValue = typeof props.value === 'number' 
    ? props.value.toFixed(0) 
    : '0';

  // Ensure x and width are converted to numbers with fallback
  const x = props.x ?? 0;
  const width = props.width ?? 0;
  const y = props.y ?? 0;

  return (
    <text 
      x={Number(x) + Number(width) + 25} 
      y={Number(y) + 10} 
      fill="#666" 
      textAnchor="middle" 
      dominantBaseline="middle"
    >
      {`${safeValue}`} %
    </text>
  );
};

// Render chart component
export const ThrowingStatsChart: React.FC<{
  title?: string;
  chartData: any[];
  height: number;
}> = ({ title, chartData, height }) => {
  return (
    <Box width="100%" height={height}>
      {title && (
        <Typography variant="h6" textAlign="center" mb={2}>
          {title}
        </Typography>
      )}
      <ResponsiveContainer width="100%" height="80%">
        <BarChart 
          data={chartData}
          margin={{ top: 20, right: 50, left: 30, bottom: 5 }}
          layout="vertical"
        >
          <XAxis type="number" />
          <YAxis dataKey="name" type='category' />
          <Tooltip content={<CustomTooltip />} />
          <Bar 
            dataKey="value" 
            fill={"#0000FF"} 
            label={<BarLabel />}
          />
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default ThrowingStatsChart;
